import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=b40717b4&scoped=true&"
import script from "./mall.vue?vue&type=script&lang=js&"
export * from "./mall.vue?vue&type=script&lang=js&"
import style0 from "./mall.vue?vue&type=style&index=0&id=b40717b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40717b4",
  null
  
)

export default component.exports